import React from 'react'

import { useGlobalContext } from '../context'

function Checkout() {
    const { dropdown } = useGlobalContext();
    return (
        <React.Fragment>
            {   
                dropdown.map((player, index) => {
                    return (
                        <div key={index} className="checkout col-md-3 mb-3 ml-5">
                            <div className="card ">
                                <div className="img-container">
                                    <img src={`./img/${player.path}.png`} className="medium card-img-top store-img img-fluid" alt="xx"/>
                                </div>
                                <div className="card-body">
                                    <div className="card-text d-flex justify-content-between text-capitalize">
                                        <h6 id="store-item-name">{player.name}</h6>
                                        <h6 className="store-item-value">$ <strong id="store-item-price" className="font-weight-bold">{player.price}</strong></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </React.Fragment>
    )
}

export default Checkout